
import {
    backend_url,
    uninterceptedAxiosInstance,
  } from "../common/commonVariables";


export const createNewInventory = async (
    name,
    description,
    category,
    measuringUnit,
    type,
    isNonStock,
    qrcode,
    barcode,
    serialNumber,
    vendors,
    assets,
    people,
    teams,
    logo,
    files,
    organisation = "",
    createdByUser = null,
    inventory
  
  ) => {
    try {
      let params = {
        name,
        description,
        category,
       
        measuringUnit,
        type,
        isNonStock,
        qrcode,
        barcode,
        serialNumber,
        vendors,
        assets,
        people,
        teams,
        logo,
        files,
        organisation,
        createdByUser,
        inventory,
      
      };
     
  
      const response = await uninterceptedAxiosInstance.post(
        backend_url + "parts",
        { data: params },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response;
     
      return the_response;
    } catch (err) {
     
      if (err.response) {
       
      } else if (err.request) {
      
      } else {
        
      }
   
      return {
        status: err.response.status,
        error: err.response?.data?.error,
      };
    }
  };

  export const createBulkPart = async (data = [], organisationId = null) => {
    try {
      let params = {
        data,
        organisation: organisationId,
      };
  
      const response = await uninterceptedAxiosInstance.post(
        backend_url + "parts/import",
        params,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
      let the_response = response;
      return the_response;
    } catch (err) {
      
      if (err.response) {
        
      } else if (err.request) {
        
      } else {
        
      }
     
      return {
        status: err?.response?.status,
      };
    }
  };

  export const updateInventory = async (
    id,
    name,
    description,
    category,
    measuringUnit,
    type,
    isNonStock,
    qrcode,
    barcode,
    serialNumber,
    vendors,
    assets,
    people,
    teams,
    logo,
    files,
    organisation = "",
    createdByUser = null,
    inventory

  ) => {
    try {
      let params = {
        name,
        description,
        category,
        measuringUnit,
        type,
        isNonStock,
        qrcode,
        barcode,
        serialNumber,
        vendors,
        assets,
        people,
        teams,
        logo,
        files,
        organisation,
        createdByUser,
        inventory,

      };
  
      const response = await uninterceptedAxiosInstance.put(
        backend_url + "parts/" + id,
        { data: params },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response;
    
      return the_response;
    } catch (err) {
     
      if (err.response) {
     
      } else if (err.request) {
       
      
      } else {
       
      }
     
      return {
        status: err.response.status,
        error: err.response?.data?.error,
      };
    }
  };

  export const deletePart = async (ID,reason) => {
    try {
      let params = {
        data: [
          {
            id: ID,
            deleteReason: reason,
          },
        ],
      };

      
      const response = await uninterceptedAxiosInstance.post(
        backend_url + "parts/removeParts",
        params,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response;

      return the_response;
    } catch (err) {
      
      if (err.response) {
     
      } else if (err.request) {
     
      } else {

       
      }
      return {
        status: err?.response?.status,
      };
     
    }
  };

  export const restockQuantity = async (
    location,
    unitCost,
    totalCost,
    quantity,
    attachments,
    createdByUser,
    organisation,
    part
  ) => {
    try {
      let params = {
        location,
        unitCost,
        totalCost,
        
        quantity,
        attachments,
        createdByUser,
        organisation,
        part,
      };
  
      const response = await uninterceptedAxiosInstance.post(
        backend_url + "restock-parts",
        { data: params },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response;
     
      return the_response;
    } catch (err) {
      
      if (err.response) {

      } else if (err.request) {
       
      } else {
        
      }
   
      return {
        status: err.response.status,
        error: err.response?.data?.error,
      };
    }
  };